
// @ts-nocheck





import { i18nText } from '@/locales';


import {RouterProperties} from '@/router/routerProperties';
import {appFiltersStore} from '@/store/modules/appFilters';
import {SalonsStore} from '@/store/modules/Salons';
import {AppFilters} from '@/UI/components/extFilter/AppFilters';
import {NewProxyDataForm} from '@/UI/components/Helpers/NewProxyDataForm';
import {Component} from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import {ClientsStore} from '@/store/modules/Clients';
import {LoyaltySubscriptionTypeStore} from '@/store/modules/Loyalty/Subscription/LoyaltySubscriptionType';
import LoyaltySubscriptionAddComponent
  from '@/UI/components/forms/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscriptionAddComponent.vue';
import LoyaltySubscriptionUpdateComponent
  from '@/UI/components/forms/loyalty/loyaltySubscription/loyaltySubscription/LoyaltySubscriptionUpdateComponent.vue';
import AppFilterTable from '@/UI/components/extFilter/AppFilterTable.vue';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import ModalWrapper from '@/UI/components/common/ModalWrapper.vue';
import {Button, Menu, List, Table, Select, Tabs, Modal, FormModel} from 'ant-design-vue';
import {mixins} from 'vue-class-component';
import {FilterList} from '@/entity/filters/extFilter';
import {SalonsMix} from '@/UI/mixins/SalonsMix';
import {SubscriptionMix} from '@/UI/mixins/Loaylty/SubscriptionMix';
import {SubscriptionTypeMix} from '@/UI/mixins/Loaylty/SubscriptionTypeMix';
import {ClientsMix} from '@/UI/mixins/ClientsMix';
import i18n from '@/locales';
import {loyaltySubscriptionForm, FormRules} from '@/form/loyalty/loyaltySubscription/loyaltySubscription';
import {LoyaltySubscriptionStore} from '@/store/modules/Loyalty/Subscription/LoyaltySubscription';
import {
  ILoyaltySubscriptionType
} from '@/entity/loyalty/loyaltySubscription/loyaltySubscriptionType/LoyaltySubscriptionType.types';
import {getStudioId} from '@/UI/lib/state';
import moment from 'moment';
import {TableColumns} from "@/UI/pages/loyalty/lib/table"
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import {checkUserRole} from "@/router/Lib/helper";
import {CashboxStore} from "@/store/modules/Finance/Cashbox";
import {LoyaltySubscriptionAddRequestType} from "@/form/loyalty/loyaltySubscription/loyaltySubscription.types";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import FilterTableComponent from "@/UI/components/Helpers/filterAndSorted/FilterTableComponent.vue"

import {FiltersData} from "@/entity/filters/extFilter";

@Component({
  components: {
    "a-button": Button,
    "a-menu-item": Menu.Item,
    "a-list-item": List.Item,
    "a-list-item-meta": List.Item.Meta,
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-table": Table,
    "a-tab": Tabs,
    "a-tab-pane": Tabs.TabPane,
    "a-modal": Modal,
    "a-form-model": FormModel,
    "a-form-model-item": FormModel.Item,

    ModalWrapper,
    PageTitle,
    LoyaltySubscriptionAddComponent,
    LoyaltySubscriptionUpdateComponent,
    BaseDataForm,
    SortComponent,
    FilterTableComponent
  },
})
export default class LoyaltySubscription extends mixins(
  ProxyGetData,
  SalonsMix,
  ClientsMix,
  SubscriptionMix,
  SubscriptionTypeMix,
  TableColumns
) {
  SubscriptionNumber = Math.floor(10000000 + Math.random() * 90000000);
  form = new loyaltySubscriptionForm();
  Rules = FormRules;
  loading = true;
  modalTitle = '';
  showModal = false;
  subscriptionEditMode = 0
  filtersData = new FiltersData();

  get cashbox() {
    return CashboxStore.items?.data;
  }

  async createSubscription(): Promise<void> {
    await LoyaltySubscriptionTypeStore.fetchAll({
      limit: this.AppPageParams.pageSize,
      filter: {salon_id: this.$store.state.salon_id},
    });
    await this.SearchClients("");
    this.form = new loyaltySubscriptionForm();
    this.showModal = true;
    this.subscriptionEditMode = 0;
  }

  dateSale(record: Record<any, any>): string {
    return moment(record.created_at).format("DD MMMM yyyy" + " " + i18nText("в") + " " + "HH:mm");
  }

  dateActivated(record: Record<any, any>): string {
    return moment(record.active_from).format("DD MMMM yyyy" + " " + i18nText("в") + " " + "HH:mm");
  }

  dateActiveTo(record: Record<any, any>): string {
    return record.active_to
      ? moment(record.active_to).format("DD MMMM yyyy") + " " + i18nText("в") + " " + record.active_to.substr(11, 5)
      : "";
  }

  async getSelectedType(recordId: number): any {
    const selectedType = await LoyaltySubscriptionTypeStore.fetchSubscriptionTypeById({filter: {id: recordId}});
    if (this.loyaltySubscriptionTypes.data.length > 10) {
      this.loyaltySubscriptionTypes.data.shift();
    }
    this.loyaltySubscriptionTypes.data.unshift(selectedType.data[0]);
  }

  async editCard(record: LoyaltySubscriptionAddRequestType): Promise<void> {
    this.form.setFormData(record);
    this.form.total_sum = Number(record.total_sum);
    this.form.cashbox_id = 0;
    this.form.cashbox_sum = 0;
    this.subscriptionEditMode = 1;
    await this.getSelectedType(record.membership_type_id);
    this.showModal = true;
  }

  async fetchTotalSum(): Promise<void> {
    let total_sum = LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes?.data.find((item: any) => {
      return item.id === this.form.membership_type_id;
    });
    if (total_sum?.price) {
      this.form.total_sum = Number(total_sum?.price);
    }
    if (this.form.membership_type_id) {
      this.form.total_sum =
        Number(this.form.total_sum) - (Number(total_sum?.price) * Number(this.form.discount)) / 100;
    }
    if (!this.form.cashbox_sum) {
      this.form.cashbox_sum = this.form.total_sum;
    }
  }

  get loyaltySubscriptionTypes(): ILoyaltySubscriptionType | null {
    return LoyaltySubscriptionTypeStore.loyaltySubscriptionTypes;
  }

  async searchDataTypes(value: string): Promise<void> {
    await LoyaltySubscriptionTypeStore.fetchAll({limit: 10, filter: {name: value, salon_id: getStudioId(this)}});
  }

  async SearchClients(value: string): Promise<void> {
    await ClientsStore.fetchAll({
      limit: this.AppPageParams.pageSize,
      filter: {salon_id: this.$store.state.salon_id, name: value},
    });
  }

  onPay(): void {
    this.form.proceed_payment = true;
    this.onSubmit();
  }

  onSubmit(): void {
    (this.$refs.subscriptionForm as FormModel).validate(async (valid) => {
      if (valid) {
        if (this.subscriptionEditMode === 0) {
          try {
            this.form.salon_id = this.$store.state["salon_id"];
            let response = await LoyaltySubscriptionStore.create(this.form);

            if (response && response.status) {
              this.$message.success(response.response);
              await this.getData();
              this.showModal = false;
            } else {
              this.$message.error(response.response);
            }
          } catch (e) {
            console.log(e);
          }
        }
        if (this.subscriptionEditMode === 1) {
          let response = await LoyaltySubscriptionStore.update(this.form);
          if (response && response.status) {
            this.$message.success(response.response);
            await this.getData();
            this.showModal = false;
          } else {
            this.$message.error(response.response);
          }
        }
      }
    });
  }

  handleCancel(): void {
    this.showModal = false;
  }

  setFilters(that: any): void {
    this.filtersData.filters.push({
        key: 0,
        type: "datetimerange",
        label: i18nText("Период продаж"),
        defaultValue: 0,
        filtered: false,
        fieldNames: ["partner_id"],
        async onChange(value: any) {
          console.log(value)
          let filter = {}
          if (value.length) {
            filter = {
              created_at_from: value[0].format("DD.MM.YYYY"),
              created_at_to: value[1].format("DD.MM.YYYY")
            }
          } else {
            filter = {
              created_at_from: '0',
              created_at_to: '0'
            }
          }
          await that.filterData(filter)
        },
        async ok(value: any) {
          let filter = {}
          if (value.length) {
            filter = {
              created_at_from: value[0].format("DD.MM.YYYY"),
              created_at_to: value[1].format("DD.MM.YYYY")
            }
          } else {
            filter = {
              created_at_from: '0',
              created_at_to: '0'
            }
          }
          await that.filterData(filter)
        },
      },
      {
        key: 3,
        type: "input",
        label: i18nText("ФИО клиента"),
        defaultValue: 0,
        placeholder: i18nText("ФИО клиента "),
        filtered: false,
        fieldNames: ["target_value"],
        async onChange(value: any) {
          await that.filterData({client_name: value.target.value})
        },
      },

      {
        key: 4,
        type: "input",
        label: i18nText("Телефон клиента"),
        defaultValue: 0,
        placeholder: i18nText("Телефон клиента"),
        filtered: false,
        fieldNames: ["target_value"],
        async onChange(value: any) {
          await that.filterData({client_phone: value.target.value})
        },
      },
      {
        key: 5,
        type: "datetimerange",
        label: i18nText("Дата сгорания"),
        defaultValue: 0,
        placeholder: "",
        value: [],
        source: [],
        fieldNames: ["sold"],
        filtered: false,
        async onChange(value: any) {
          console.log(value)
          let filter = {}
          if (value.length) {
            filter = {
              expired_date_from: value[0].format("DD.MM.YYYY"),
              expired_date_to: value[1].format("DD.MM.YYYY")
            }
          } else {
            filter = {
              expired_date_from: '0',
              expired_date_to: '0'
            }
          }
          await that.filterData(filter)
        }
      },
      {
        key: 6,
        type: "range-input",
        label: i18nText("Остаток кол-ва посещений"),
        defaultValue: 0,
        placeholder: "",
        max: 4,
        value: [],
        source: [],
        fieldNames: ["sold"],
        filtered: false,
        async okRange(key1: any, key2: any) {
          await that.filterData({balance_from: parseInt(key1), balance_to: parseInt(key2)})
        },
      },
    );
    this.filter_load = true;
  }

  async created(): Promise<void> {
    if (!this.formReady) {
      try {
        this.proxyFilter = {
          salon_id: getStudioId(this)
        };
        appPaginationStore.setCurrent(1);
        await this.sortedData("desc", {dataIndex: "created_at"});
        await this.fetchModules([{s: "category", p: {limit: -1}}]);
        this.setFilters(this);

        if (!SalonsStore.ready) {
          const Role = checkUserRole();
          let data: Record<any, any> = {limit: this.AppPageParams.pageSize, filter: {}}
          if (Role === "owner") {
            data['filter']['salon_id'] = getStudioId(this);
          }
          await SalonsStore.fetchAll(data);
        }

        await CashboxStore.fetchAll({filter: {salon_id: getStudioId(this)}});

        if (!ClientsStore.ready) {

          await ClientsStore.fetchAll({
            limit: this.AppPageParams.pageSize,
            filter: {salon_id: getStudioId(this)}
          });
        }
        await LoyaltySubscriptionTypeStore.fetchAll({
          limit: this.AppPageParams.pageSize,
          filter: {salon_id: getStudioId(this)}
        });
      } catch (e) {
        console.error(e);
        console.log('Error loading settings');
      } finally {
        await SalonsStore.setReady(true);
        await ClientsStore.setReady(true);
        this.formReady = true;
        this.form.membership_number = this.SubscriptionNumber;
      }
    }
  }

  async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
    await this.filterData(appFiltersStore.filter);
    await this.sortedData(by, {dataIndex: sort.dataIndex});
  }

  async clearFilter(clear: string): Promise<void> {
    await this.sortedData("desc", {dataIndex: "active_from"});
  }

  async clearAFilter(): Promise<void> {
    console.log("clearAFilter");
    this.proxyFilter = {
      salon_id: getStudioId(this),
    };
    for (let i of this.filtersData.filters) {
      i.default_value = [i18nText("Не указано")];
    }
    await this.sortedData("desc", {dataIndex: "created_at"});
  }
}
